import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/equipmentLive/pdf.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-02ae76b0"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "drawing"
};
var _hoisted_2 = ["onClick"];
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0
  }, null, -1);
});
var _hoisted_4 = {
  class: "text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_c_nothing = _resolveComponent("c-nothing");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.useList.length ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList(_ctx.useList, function (item) {
    return _openBlock(), _createElementBlock("div", {
      class: "list-item",
      key: item.name,
      onClick: function onClick($event) {
        return _ctx.itemClick(item);
      }
    }, [_hoisted_3, _createElementVNode("span", _hoisted_4, _toDisplayString(item.name), 1)], 8, _hoisted_2);
  }), 128)) : (_openBlock(), _createBlock(_component_c_nothing, {
    key: 1
  }))]);
}